<nz-modal [(nzVisible)]="isVisible" [nzContent]="modalContent" [nzFooter]="null" [nzClosable]="false" nzWidth="800px">
  <ng-template #modalContent>
    <div nz-row style="padding-bottom: 10px;">
      <div nz-col nzSpan="23">
        <div class="detail-title-text sub-header-font-size">{{'F0000.F0019' | translate}}</div>
      </div>
      <div nz-col nzSpan="1">
        <div class="detail-title-text" (click)="handleCancel()" style="text-align: right;">X</div>
      </div>
    </div>
    <nz-select class="body-font-size" nzShowSearch nzServerSearch nzPlaceHolder="{{'F0000.F0019' | translate}}" [(ngModel)]="selectedValue"
      [nzShowArrow]="true" [nzFilterOption]="nzFilterOption" (nzOnSearch)="search($event)"
      (ngModelChange)="sendData($event)">
      <nz-option class="body-font-size" *ngFor="let o of listOfOption" [nzLabel]="o.text" [nzValue]="o.value"> </nz-option>
    </nz-select>
    <div class="break"></div>
    <nz-tree #nzTreeComponent class="body-font-size" style="text-align: left;" [nzExpandAll]="false" nzVirtualHeight="620px" [nzData]="nodes" (nzClick)="nzEvent($event)"
      (nzExpandChange)="nzEvent($event)">
    </nz-tree>
    <div class="break"></div>
  </ng-template>
</nz-modal>